import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Settings } from '../../../constants/app-settings';

@Component({
    selector: 'admin-custom-scripts-edit-modal',
    templateUrl: './admin-custom-scripts-edit-modal.component-ng.html',
    styleUrls: ['./admin-custom-scripts-edit-modal.component.scss']
})
export class AdminCustomScriptsEditModalComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() id: number;
    @Input() dealerId: number;
    @Input() scriptTypeId: number;
    @Input() culture: string;
    @Output() saveChanges = new EventEmitter();
    @ViewChild('legacyFrame', { static: false }) legacyFrame: ElementRef<HTMLIFrameElement>;

    public url: string = '';
    public showUnsavedPrompt = false;
    private legacyOrigin = '';
    private legacyDirty = false;
    private messageHandler: (event: MessageEvent) => void;

    constructor(public _bsModalRef: BsModalRef) {}

    ngOnInit(): void {
        const baseUrl = Settings.legacy.iframeUrl + '/Settings/OutreachTemplates/CustomScriptEditModal/?dealerID=' + this.dealerId;
        if (this.id && this.id > 0) {
            this.url = baseUrl + '&id=' + this.id;
        } else {
            const culture = this.culture || 'en-US';
            const scriptTypeId = this.scriptTypeId || 0;
            this.url = baseUrl + '&scriptTypeID=' + scriptTypeId + '&culture=' + encodeURIComponent(culture);
        }
        this.legacyOrigin = this.getOrigin(this.url);
        this.messageHandler = (event: MessageEvent) => this.onMessage(event);
        window.addEventListener('message', this.messageHandler);
        this._bsModalRef.hide();
    }

    ngAfterViewInit(): void {
        this._bsModalRef.hide();
    }

    ngOnDestroy(): void {
        if (this.messageHandler) {
            window.removeEventListener('message', this.messageHandler);
        }
    }

    public onFrameLoad(): void {
        this.postToLegacy({ type: 'CustomScriptStateRequest' });
    }

    public onCancel(): void {
        if (this.isLegacyDirty()) {
            this.showUnsavedPrompt = true;
            return;
        }
        this.closeModal();
    }

    public onUnsavedDiscard(): void {
        this.showUnsavedPrompt = false;
        this.closeModal();
    }

    public onUnsavedCancel(): void {
        this.showUnsavedPrompt = false;
    }

    private closeModal(): void {
        this.saveChanges.emit();
        this._bsModalRef.hide();
    }

    private isLegacyDirty(): boolean {
        return this.legacyDirty;
    }

    private overrideLegacyClose(): void {
        return;
    }

    private getLegacyWindow(): any {
        if (!this.legacyFrame || !this.legacyFrame.nativeElement) {
            return null;
        }
        return this.legacyFrame.nativeElement.contentWindow;
    }

    private postToLegacy(payload: { type: string }): boolean {
        const legacyWindow = this.getLegacyWindow();
        if (!legacyWindow) {
            return false;
        }
        legacyWindow.postMessage({ ...payload, source: 'CustomScriptsEdit' }, '*');
        return true;
    }

    private onMessage(event: MessageEvent): void {
        if (!event.data || event.data.source !== 'CustomScriptsEdit') {
            return;
        }

        switch (event.data.type) {
            case 'CustomScriptDirty':
                this.legacyDirty = Boolean(event.data.isDirty);
                break;
            case 'CustomScriptClose':
                this.closeModal();
                break;
            default:
                break;
        }
    }

    private getOrigin(url: string): string {
        try {
            const parsed = new URL(url);
            return parsed.origin;
        } catch (error) {
            return '';
        }
    }
}
